import { render } from "./WCOrderTypeCollapseCardBody.vue?vue&type=template&id=54078bfb&scoped=true"
import script from "./WCOrderTypeCollapseCardBody.vue?vue&type=script&lang=js"
export * from "./WCOrderTypeCollapseCardBody.vue?vue&type=script&lang=js"

import "./WCOrderTypeCollapseCardBody.vue?vue&type=style&index=0&id=54078bfb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54078bfb"]])

export default __exports__